import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function About() {
    const [loading, setLoading] = useState(false);
    const [view, setView] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setLoading(true);
        }, 5000);
        setTimeout(() => {
            setView(false);
        }, 15000);
    }, []);

    return (
        <div className="w-screen h-screen">
            <style jsx>
                {`
                    .loader {
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        max-width: 6rem;
                        margin-top: 3rem;
                        margin-bottom: 3rem;
                    }
                    .loader:before,
                    .loader:after {
                        content: "";
                        position: absolute;
                        border-radius: 50%;
                        animation: pulsOut 1.8s ease-in-out infinite;
                        filter: drop-shadow(0 0 1rem rgba(255, 255, 255, 0.75));
                    }
                    .loader:before {
                        width: 100%;
                        padding-bottom: 100%;
                        box-shadow: inset 0 0 0 1rem #fff;
                        animation-name: pulsIn;
                    }
                    .loader:after {
                        width: calc(100% - 2rem);
                        padding-bottom: calc(100% - 2rem);
                        box-shadow: 0 0 0 0 #fff;
                    }

                    @keyframes pulsIn {
                        0% {
                            box-shadow: inset 0 0 0 1rem #fff;
                            opacity: 1;
                        }
                        50%,
                        100% {
                            box-shadow: inset 0 0 0 0 #ff00f5;
                            opacity: 0;
                        }
                    }

                    @keyframes pulsOut {
                        0%,
                        50% {
                            box-shadow: 0 0 0 0 #fff;
                            opacity: 0;
                        }
                        100% {
                            box-shadow: 0 0 0 1rem #fff;
                            opacity: 1;
                        }
                    }
                `}
            </style>
            {view && (
                <div className="fixed top-12 right-8 rounded-xl bg-slate-800 p-2 px-5 text-white text-xs">
                    Use arrow keys or tap on the screen to slide
                    <button
                        className="p-2 ml-2 text-red-400"
                        onClick={() => setView(!view)}
                    >
                        x
                    </button>
                </div>
            )}

            <div
                className={` ${
                    loading ? "opacity-0 pointer-events-none" : "opacity-100"
                } w-screen fixed top-0 left-0 anim flex flex-col justify-center toppp bg-black items-center h-screen`}
            >
                <span class="loader"></span>
                <p className="text-white/50 animate-pulse mt-6 text-xs">
                    Hang on, it's loading...
                </p>
            </div>
            <div className="w-screen fixed bottom-0 left-0 h-16  bg-[#0E0E0E]">
                <Link
                    className="text-white mx-auto mt-8 block w-fit hover:text-white/80 transition-all duration-500 ease-in-out"
                    to="/"
                >
                    Back
                </Link>
            </div>
            <iframe
                title="persontation"
                width={"100%"}
                height={"100%"}
                src="https://www.figma.com/embed?embed_host=share&hide_ui=1&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FSKNXW4NwmkyM7fPvhcAmHX%2FPersontation-HP%3Fpage-id%3D0%253A1%26type%3Ddesign%26node-id%3D2-2%26viewport%3D341%252C204%252C0.06%26t%3DNfmZyTiUw1cylDMR-1%26scaling%3Dscale-down%26starting-point-node-id%3D2%253A2%26&hide_ui=1"
                allowfullscreen
            ></iframe>
        </div>
    );
}
